import { CSSProperties, ReactNode } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { TH } from '../../primitives/InstantGridStyles'
import vars from '../../styles/variables'

export const COLUMN_DND_TYPE = 'column'

interface DragItem {
  dataIndex: string
}

interface Props {
  dataIndex: string
  onReorder: (dragDataIndex: string, dropDataIndex: string) => void
  style?: CSSProperties
  children: ReactNode
}

export const InstantGridColumnHeader = ({ dataIndex, onReorder, style, children }: Props) => {
  const [{ isOver }, drop] = useDrop<DragItem, void, { isOver: boolean }>(
    () => ({
      accept: COLUMN_DND_TYPE,
      collect: (monitor) => ({ isOver: monitor.isOver() }),
      drop: (item) => {
        if (item.dataIndex !== dataIndex) {
          onReorder(item.dataIndex, dataIndex)
        }
      }
    }),
    [dataIndex, onReorder]
  )

  const [{ isDragging }, drag] = useDrag<DragItem, void, { isDragging: boolean }>(
    () => ({
      type: COLUMN_DND_TYPE,
      item: { dataIndex },
      collect: (monitor) => ({ isDragging: monitor.isDragging() })
    }),
    [dataIndex]
  )

  return (
    <TH
      ref={(el) => {
        drag(drop(el))
      }}
      style={{
        ...style,
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: isDragging ? 0.4 : 1,
        borderLeft: isOver ? `2px solid ${vars.newColors.primary}` : '2px solid transparent'
      }}
    >
      {children}
    </TH>
  )
}
